<template>
  <div class="form">
    <div class="form-content clearfix">
      <div v-if="selectedForm.length !== 0">
        <div class="form-row" v-for="(component, index) in selectedForm" :key="index">
          <v-layout
            align-start
            justify-start
            v-if="component.controlName === 'titleBar' && component.show !== false"
            class="titleBar clearfix"
          >
            <v-flex lg12>
              <div class="stepHeader">
                <v-layout :class="[component.customClass, 'form-control']">
                  <v-flex>
                    <span
                      :autoid="component.autoid"
                      v-text="getStringDynamicValue(component.displayName)"
                    ></span>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>
          <div class="form-item-ctr">
            <div class="form-item">
              <conditional-render :dataProps="component" />
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="form-row reviewCtr" v-for="(component, index) in mergedForm" :key="index">
          <review-render :dataProps="component"></review-render>
        </div>
      </div>
    </div>
    <div class="footerBtnCtr">
      <v-layout justify-end>
        <template v-for="(action, index) in actionData">
          <div v-if="action.controlName === 'button'" :key="index">
            <v-btn
              :color="action.actionType"
              :outlined="action.outlined"
              depressed
              :autoid="action.autoid"
              :disabled="
                (action.refId == 'reviewPublishBtn'
                  ? ( updatedOnPublish.disableProd 
                  ? true : 
                  updatedOnPublish.disabled )
                  : false) || (() => actionButtonClass(action))()
              "
              @click="handle_function_call(action.actionMethod)"
            >
              {{ action.displayName }}
              <span class="ml-1" v-if="action.refId == 'reviewPublishBtn'">
                {{
                updatedOnPublish.buttonText
                }}
              </span>
            </v-btn>
          </div>
        </template>
      </v-layout>
    </div>
    <div class="footer-msg-ctr">
      <template v-for="(data, index) in disclaimerData">
        <p class="disclaimer" :key="index">{{ data.message }}</p>
      </template>
    </div>
  </div>
</template>

<script>
import _ from 'underscore'
import ConditionalRender from '../../components/conditionalRender.vue'
import ReviewRender from './review.vue'
import Vue from 'vue'
import Vuex from 'vuex'
import { mapActions } from 'vuex'
import axios from 'axios'
Vue.use(Vuex)
import serviceRegistery from '../../mixins/serviceRegistery'
import { jsonHelper } from '../../mixins/jsonHelper'
import { helpers } from '../../mixins/helpers'
import { subbrandToolHelper } from '../../mixins/subbrandToolHelper'
import validatePublicKey from '../../mixins/validator'
import { custToolHelper } from '../../mixins/custToolHelper'
export default {
  data: () => ({
    isSamlCertinError: false,
    isIpAddressFieldinError: false
  }),
  $_veeValidate: {
    validator: 'new'
  },
  provide() {
    return {
      $validator: this.$validator
    }
  },
  created: function() {
    this.$store.state.createSubbrandStore.selectedDevAuthTypes = []
    this.formDataConstruct()
    var self = this

    this.$validator.extend('alpha_num_dash_spaces', {
      getMessage: field =>
        'Please use only letters, numbers, dashes, and white-spaces.',
      validate: value => {
        var validData = true
        // var regex = new RegExp('^[a-zA-Z0-9]+((\\s|-)[a-zA-Z0-9-]+)*$')
        var regex = new RegExp(
          '^[a-zA-Z]{1}[a-zA-Z0-9-]*((\\s-|-\\s|-|\\s)[a-zA-Z0-9-]+)*((\\s-|-\\s|-|\\s|)[a-zA-Z0-9]+)+$'
        )
        if (!regex.test(value.trim())) {
          validData = false
        }
        return validData
      }
    })
    this.$validator.extend('alpha_spaces', {
      getMessage: field =>
        'Please use only letters and white-spaces.',
      validate: value => {
        var validData = true
        var regex = new RegExp(
          '^([a-zA-Z]+\\s)*[a-zA-Z]+$'
        )
        if (!regex.test(value.trim())) {
          validData = false
        }
        return validData
      }
    })
    this.$validator.extend('alpha_num_dash', {
      getMessage: field => 'Please use only letters, numbers and dashes.',
      validate: value => {
        var validData = true
        // var regex = new RegExp('^[a-zA-Z0-9]+[a-zA-Z0-9-]*$')
        var regex = new RegExp('^[a-zA-Z][a-zA-Z0-9]+[a-zA-Z0-9-]*[a-zA-Z0-9]$')
        if (!regex.test(value.trim())) {
          validData = false
        }
        return validData
      }
    })
    this.$validator.extend(
      'isNotSame',
      {
        getMessage: field =>
          'Already exists! Please enter a different ' + field + '.',
        validate: (value, [otherValue]) => {
          var otherDefaultValue = $('.' + otherValue + ' input').val()
          return value != otherDefaultValue
        }
      },
      {
        hasTarget: true
      }
    )

    this.$validator.extend(
      'isNotSameTextArea',
      {
        getMessage: field =>
          'Already exists! Please enter a different ' + field + '.',
        validate: (value, [otherValue]) => {
          var otherDefaultValue = $('.' + otherValue + ' textarea').val()
          return value != otherDefaultValue
        }
      },
      {
        hasTarget: true
      }
    )

    this.$validator.extend('isValidRsaKey', {
      getMessage: field => 'RSA Public key is not valid.',
      validate: value => {
        return validatePublicKey.validatePublicKey(value)
      }
    })
  },
  mixins: [jsonHelper, subbrandToolHelper, helpers, custToolHelper],
  components: {
    'conditional-render': ConditionalRender,
    'review-render': ReviewRender
  },
  watch: {
    selectedForm: {
      deep: true,
      handler: 'updateEditStatus'
    }
  },
  computed: {
    subbrandDataChanged() {
      return this.$store.state.createSubbrandStore.subbrandDataChanged
    },
    selectedForm() {
      return this.$store.state.createSubbrandStore.selectedForm
    },
    actionData() {
      return this.$store.state.createSubbrandStore.actionData
    },
    disclaimerData() {
      return this.$store.state.createSubbrandStore.disclaimerData
    },
    channelBrandConfig () {
      return this.$store.state.createSubbrandStore.channelBrandConfig
    },
    mergedForm() {
      var self = this
      let templateMergedData = this.$store.state.createSubbrandStore
        .createTemplateData
      let mergeForm = []
      let mergeProds = []
      let selectedAuthType = []
      let selectedApiProdsIndex = null
      templateMergedData.content.forEach(content => {
        content.form.forEach(item => {
          if (item.reviewRef === 'selectedApiProds') {
            if (item.defaultValue) {
              mergeProds.push(item)
            }
            if (selectedApiProdsIndex === null) {
              mergeForm.push(item)
              selectedApiProdsIndex = mergeForm.length - 1
            } else {
              if (item.defaultValue) {
                mergeForm.push(item)
              }
            }
          } else if (content.stepId == 'prodAppSelection') {
            this.toggleAppSection(content)
            if (item.show != false) {
              mergeForm.push(item)
            }
          } else if (content.stepId == 'contactDetails') {
            this.updateReviewUserIdShowHide(content)
            this.updateReviewContactMember2ShowHide(content)
            if (item.show != false && item.refId != 'addAnotherContactBtn') {
              mergeForm.push(item)
            }
          } else if (
            content.stepId == 'authStageSetup' ||
            content.stepId == 'authProdSetup'
          ) {
            this.updateReviewAuthTypeFormShowHide(content, selectedAuthType)
            this.updateReviewJWT2ShowHide(content, selectedAuthType)
            if (item.show != false && item.controlName !== 'button') {
              mergeForm.push(item)
            }
          } else if (item.show === undefined || item.show === true) {
            mergeForm.push(item)
          }
        })
      })
      mergeForm[selectedApiProdsIndex].mergeProducts = mergeProds.splice(1)
      this.$store.state.createSubbrandStore.reviewform = mergeForm
      return this.$store.state.createSubbrandStore.reviewform
    },
    updatedOnPublish() {
      let selectedSubbrandInfo = this.$store.state.appStore.selectedSubbrandInfo
      return this.envMapping(selectedSubbrandInfo)
    }
  },
  methods: {
    ...mapActions(['formDataConstruct']),
    actionButtonClass(action) {
      if (
        action.refId === 'customizeAppsBtn' &&
        this.$store.state.createSubbrandStore.customerType == 'API'
      ) {
        return true
      } else {
        return false
      }
    },
    getStringDynamicValue(text) {
      let subbrandName = this.$store.state.appStore.selectedSubbrandInfo.name
      let string = text.replace(/_SUB-BRAND-NAME_/, subbrandName)
      return string
    },
    addErrorMessage(field, msg) {
      this.errors.add({
        field,
        msg
      })
    },
    saveGeneralConfig() {
      this.continueStep()
    },
    getSamlObj() {
      let currentStepData = this.selectedForm
      let saml = _.findWhere(currentStepData, {
        refId: 'saml'
      })
      return saml
    },
    getJwtObj() {
      let currentStepData = this.selectedForm
      let jwtObj = _.findWhere(currentStepData, {
        refId: 'jwt'
      })
      return jwtObj
    },
    getSamlCertificateObj(certRefid) {
      let saml = this.getSamlObj()
      let samlCert = _.findWhere(saml.formData, {
        refId: certRefid
      })
      return samlCert
    },
    saveDevAuthSetup() {
      this.saveAuthSetup('DEVELOPMENT')
    },
    saveProdAuthSetup() {
      this.saveAuthSetup('PRODUCTION')
    },
    saveAuthSetup(env) {
      let samlObj = this.getSamlObj()
      let jwtObj = this.getJwtObj()
      let envmt = env

      let samlCertObj
      if (envmt === 'DEVELOPMENT') {
        samlCertObj = this.getSamlCertificateObj('samlCertdev')
      } else if (envmt === 'PRODUCTION') {
        samlCertObj = this.getSamlCertificateObj('samlCertprod')
      }

      if (samlObj && samlObj.show && (jwtObj && jwtObj.show)) {
        if (samlCertObj.defaultValue === '' && !$('#files')[0].files[0]) {
          this.isSamlCertinError = true
          samlCertObj.showError = true
          samlCertObj.errorMessage = 'Required field.'
          this.continueStep()
        } else {
          this.isSamlCertinError = false
          samlCertObj.showError = false
          this.uploadCertificate(envmt, samlCertObj)
        }
      } else if (samlObj && samlObj.show) {
        if (samlCertObj.defaultValue === '' && !$('#files')[0].files[0]) {
          this.isSamlCertinError = true
          samlCertObj.showError = true
          samlCertObj.errorMessage = 'Required field.'
          this.continueStep()
        } else {
          this.isSamlCertinError = false
          samlCertObj.showError = false
          samlCertObj.errorMessage = ''
          this.uploadCertificate(envmt, samlCertObj)
        }
      } else if (jwtObj && jwtObj.show) {
        samlCertObj.showError = false
        samlCertObj.errorMessage = ''
        this.isSamlCertinError = false
        this.continueStep()
      } else {
        console.log('something is wrong')
        samlCertObj.defaultValue = ''
        this.continueStep()
      }
    },
    uploadCertificate(env, samlCertObj) {
      let samlCert = samlCertObj

      if (samlCert.defaultValue && !$('#files')[0].files[0]) {
        this.continueStep()
      } else if (
        /\.(cert|cer)$/i.test($('#files')[0].files[0].name) === false
      ) {
        this.isSamlCertinError = true
        samlCert.showError = true
        samlCert.errorMessage =
          'Please select the correct format(.cert or .cer).'
        this.continueStep()
      } else if ($('#files')[0].files[0]) {
        let formdata = new FormData()

        formdata.append('resource', $('#files')[0].files[0])
        formdata.append(
          'cobrand',
          this.$store.state.appStore.selectedSubbrandInfo._id
        )
        formdata.append('type', 'SAML_CERT')
        formdata.append('environment', env)

        serviceRegistery
          .makeCall({
            url: this.$hostname + 'services/resource/upload',
            method: 'PUT',
            data: formdata,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(response => {
            samlCert.showError = false
            samlCert.errorMessage = ''
            samlCert.defaultValue = response.data.fileName
            samlCert.certId = response.data._id
            this.continueStep()
          })
          .catch(() => {
            console.log('Certificate upload failed')
            this.showToastMessage(
              'Sorry, a technical error has occurred! Please try again later.'
            )
          })
      } else {
        samlCert.showError = false
        samlCert.showError = true
        samlCert.errorMessage = 'Required field.'
        console.log('Certificate not selected')
      }
    },
    saveProdApps() {
      // Validate Current Step data and Save.
      let currentStepData = this.selectedForm
      let valid = false

      // Validate any one of the product selected.
      let prodAgg = _.findWhere(currentStepData, {
        refId: 'prodAggregation'
      })
      let prodVer = _.findWhere(currentStepData, {
        refId: 'prodVerification'
      })
      let prodFL = _.findWhere(currentStepData, {
        refId: 'productFastlink'
      })

      let wellnessApps = _.findWhere(currentStepData, {
        refId: 'productWellness'
      })

      let productError = _.findWhere(currentStepData, {
        refId: 'product-error'
      })
      let applicatonError = _.findWhere(currentStepData, {
        refId: 'application-error'
      })
      let appError = _.findWhere(currentStepData, {
        refId: 'app-error'
      })

      let selectedApps = []
      if (wellnessApps.defaultValue === true) {
        wellnessApps.formData.filter(app => {
          if (app.defaultValue === true) {
            selectedApps.push(app)
          }
        })
      }
      if (
        prodAgg.defaultValue === false &&
        prodVer.defaultValue === false &&
        (wellnessApps.defaultValue === true && selectedApps.length === 0) &&
        prodFL.defaultValue === false &&
        wellnessApps.defaultValue === false
      ) {
        productError.show = true
        applicatonError.show = true
        appError.show = true
        console.log('both are in error')
      } else if (
        prodAgg.defaultValue === false &&
        prodVer.defaultValue === false
      ) {
        productError.show = true
        applicatonError.show = false
        appError.show = false
        console.log('Products are in error')
      } else if (
        wellnessApps.defaultValue === true &&
        selectedApps.length === 0
      ) {
        applicatonError.show = true
        productError.show = false
        appError.show = false
        console.log('Applications are in error')
      } else if (
        prodFL.defaultValue === false &&
        wellnessApps.defaultValue === false
      ) {
        appError.show = true
        applicatonError.show = false
        productError.show = false
      } else {
        valid = true
        productError.show = false
        applicatonError.show = false
        appError.show = false
        this.continueStep()
      }
    },
    saveContactDetails() {
      this.continueStep()
    },
    continueStep() {
      var self = this
      this.$validator.validateAll().then(result => {
        if (!self.isSamlCertinError && !self.isIpAddressFieldinError) {
          if (result) {
            // Save current steps data after saving sucess move to next step
            // Check Config Id is present or not
            // If Config Id present Update the config data or create the Data
            let _cobrandRefId = this.$store.state.appStore.selectedSubbrandInfo
              ._id
            if (_.isEmpty(_cobrandRefId)) {
              this.createSubbrand()
            } else {
              this.updateSubbrand()
            }
          } else {
            console.log('ERROR', this.$validator)
          }
        }
        self.isSamlCertinError = false
        self.isIpAddressFieldinError = false
      })
    },
    goToNextStep() {
      let currentStep = this.$store.state.createSubbrandStore.currentStep
      this.$store.state.createSubbrandStore.currentStep = currentStep + 1

      // Get next step form data
      this.formDataConstruct()

      // Move the focus to top element
      window.scrollTo(0, 0)

      // Set focus to form element
      document.getElementById('back-to-sub-brand-list-btn').focus()
    },
    goToPreviousStep() {
      let currentStep = this.$store.state.createSubbrandStore.currentStep
      this.$store.state.createSubbrandStore.currentStep = currentStep - 1

      // Get previous step form data
      this.formDataConstruct()

      // Move the focus to top element
      window.scrollTo(0, 0)

      // Set focus to form element
      document.getElementById('back-to-sub-brand-list-btn').focus()
    },
    publishToStage() {
      var _self = this,
        envState
      let selectedSubbrandInfo = this.$store.state.appStore.selectedSubbrandInfo

      if (selectedSubbrandInfo.state == 1) {
        envState = 'DEVELOPMENT'
      } else if (
        (selectedSubbrandInfo.state == 2 && selectedSubbrandInfo.status == 5) ||
        selectedSubbrandInfo.status == 4
      ) {
        envState = 'PRODUCTION'
      }
      let reqObj = { id: selectedSubbrandInfo._id, env: envState }
      serviceRegistery
        .makeCall({
          url: this.$hostname + 'services/subbrand/publish',
          method: 'POST',
          data: reqObj
        })
        .then(response => {
          console.log('publish--->', response.data)
          this.$router.push('/dataloader')
        })
        .catch(error => {
          console.log('Error while publishing', error)
          this.showToastMessage(
            'Sorry, a technical error has occurred! Please try again later.'
          )
        })
    },
    customizeApps() {
      // To-do
      // Need to set co-brand Id and app Id in the Cust store before route
      this.$router.push('/customization')
    },
    constructSubbrandData() {
      let subbrandData = this.selectedForm
      let configData = {}
      let formData = subbrandData
      for (let j = 0; j <= formData.length - 1; j++) {
        if (formData[j] && formData[j].key) {
          this.assignFormDataObject(configData, formData[j])
        }
        if (
          (formData[j].controlName === 'formGroup' ||
            formData[j].controlName === 'productGroup') &&
          formData[j].show != false
        ) {
          let fromGroupData = formData[j].formData
          for (let l = 0; l <= fromGroupData.length - 1; l++) {
            if (fromGroupData[l] && fromGroupData[l].key) {
              this.assignFormDataObject(configData, fromGroupData[l])
            }
            let subFromGroupData = fromGroupData[l].formData
            if(subFromGroupData) {
                for (let k = 0; k <= subFromGroupData.length - 1; k++) {
                    if (subFromGroupData[k] && subFromGroupData[k].key) {
                    this.assignFormDataObject(configData, subFromGroupData[k])
                    }

                    let childFromGroupData = subFromGroupData[k].formData
                    if(childFromGroupData) {
                        for (let n = 0; n <= childFromGroupData.length - 1; n++) {
                            if (childFromGroupData[n] && childFromGroupData[n].key) {
                            this.assignFormDataObject(configData, childFromGroupData[n])
                            }
                        }
                    }
                }
            }
          }
        }
      }
      return configData
    },
    assignFormDataObject(configData, formData) {
      let validData = this.filterValidData(formData)
      if (typeof validData !== 'undefined') {
        configData[formData.key] = validData
        if (formData.sdpKey && formData.sdpValue) {
          configData[formData.sdpKey] = formData.sdpValue
        }
      }
    },

    getConfigFlowData() {
      let configStatus = {}
      configStatus.currentStep =
        this.$store.state.createSubbrandStore.currentStep + 1
      let selectedSubbrandInfo = this.$store.state.appStore.selectedSubbrandInfo
      if (
        !selectedSubbrandInfo.configStatus ||
        !selectedSubbrandInfo.configStatus.flowCompleted
      ) {
        configStatus.flowCompleted = configStatus.currentStep >= 5
      } else {
        configStatus.flowCompleted = true
      }

      return configStatus
    },
    getBrandJsonParamLocale(){
      var brandJsonData = {
        brandJson : { "cbdk" : { default : {} }},
        noChangeDataRequired : true
      }

      var channelBrandConfig = this.channelBrandConfig;
      if( !channelBrandConfig ) {
        channelBrandConfig = {};
        channelBrandConfig.param = {}
        channelBrandConfig.locale = {}
        channelBrandConfig.cbdk = {}
      }
      if( !this.$store.state.createSubbrandStore.channelBrandUpdatedData ) {
        let vueParams = JSON.parse(JSON.stringify(this.$store.state.createSubbrandStore.params));
        this.generateVueJsonParam(vueParams, channelBrandConfig.param || { default : {} });
        this.generateCobrandJsonParam(
          JSON.parse(JSON.stringify(this.$store.state.createSubbrandStore.params)),
          vueParams,
          brandJsonData
        );

        let vueLocales = JSON.parse(JSON.stringify(this.$store.state.createSubbrandStore.strings));
        this.generateVueJsonLocale(vueLocales, channelBrandConfig.locale || { default : {} })
        this.generateCobrandJsonLocale(
          JSON.parse(JSON.stringify(this.$store.state.createSubbrandStore.strings)),
          vueLocales,
          brandJsonData
        );
        this.$store.state.createSubbrandStore.channelBrandUpdatedData = brandJsonData.brandJson;
      }

      console.log('NEW SUBBRAND BRAND DATA-->', this.$store.state.createSubbrandStore.channelBrandUpdatedData)
      return JSON.parse(JSON.stringify(this.$store.state.createSubbrandStore.channelBrandUpdatedData));
    },
    createSubbrand() {
      let configData = this.constructSubbrandData()
      let subbrandDataObj = this.dotNotationJsonToObject(configData)
      let _channelId = this.$store.state.appStore.selectedChannelId

      subbrandDataObj.configStatus = this.getConfigFlowData()
      
      subbrandDataObj.brand = this.getBrandJsonParamLocale()

      let reqObj = {
        channelId: _channelId,
        jsonData: JSON.stringify(subbrandDataObj)
      }

      console.log('Create Request Obj------>', subbrandDataObj)
      serviceRegistery
        .makeCall({
          url: this.$hostname + 'services/subbrand/create',
          method: 'POST',
          data: reqObj
        })
        .then(response => {
          console.log('Sub-brand Data Saved', response.data)
          // Set Cobrand collection refrence Id
          this.$store.state.appStore.selectedSubbrandInfo = response.data
          // Move to next step
          this.goToNextStep()
        })
        .catch(error => {
          console.log('Error while saving', error.response.data)
          if (error.response.data.fields) {
            error.response.data.fields.map(key => {
              if (key == 'appext') {
                // APP EXT is not unique
                this.errors.add({
                  field: 'appext',
                  msg: 'Already exists! Please enter a different domain name.'
                })
              }
              if (key == 'name') {
                // Sub-brand name is should be unique
                this.errors.add({
                  field: 'name',
                  msg:
                    'Already exists! Please enter a different Sub-brand name.'
                })
              }
            })
          }
        })
    },
    updateSubbrand() {
      let configData = this.constructSubbrandData()
      let subbrandDataObj = this.dotNotationJsonToObject(configData)
      subbrandDataObj.configStatus = this.getConfigFlowData()
      let _id = this.$store.state.appStore.selectedSubbrandInfo._id
      let reqObj = {
        id: _id,
        jsonData: JSON.stringify(subbrandDataObj)
      }
      console.log('Update Request Obj------>', subbrandDataObj)
      serviceRegistery
        .makeCall({
          url: this.$hostname + 'services/subbrand/update',
          method: 'POST',
          data: reqObj
        })
        .then(response => {
          console.log(response)
          console.log('Sub-brand Data Updated-->', response.data)
          // Move to next step
          this.$store.state.appStore.selectedSubbrandInfo = response.data

          //Set Dev Selected Auth type
          let currentStepId = this.$store.state.createSubbrandStore
            .selectedFormId
          if (currentStepId && currentStepId == 'authStageSetup') {
            let currentStepData = this.selectedForm
            let devAuthType = _.findWhere(currentStepData, {
              refId: 'stageAuthType'
            })
            this.$store.state.createSubbrandStore.selectedDevAuthTypes =
              devAuthType.defaultValue
          }

          this.goToNextStep()
        })
        .catch(error => {
          console.log('Error while updating', error.response.data)
          if (error.response.data.fields) {
            error.response.data.fields.map(key => {
              if (key == 'appext') {
                // APP EXT is not unique
                this.errors.add({
                  field: 'appext',
                  msg: 'Already exists! Please enter a different domain name.'
                })
              }
              if (key == 'name') {
                // Sub-brand name is should be unique
                this.errors.add({
                  field: 'name',
                  msg:
                    'Already exists! Please enter a different Sub-brand name.'
                })
              }
            })
          }
        })
    },
    filterValidData(data) {
      let validData
      if (typeof data.defaultValue !== 'undefined') {
        if (data.dataType === 'string' && data.defaultValue) {
          if (data.controlName == 'textArea') {
            validData = data.defaultValue.replace(/\\n/g, '')
          } else {
            validData = data.defaultValue.trim()
          }
        } else if (data.dataType === 'array' && data.defaultValue.length > 0) {
          validData = data.defaultValue
        } else if (data.dataType === 'boolean') {
          validData = data.defaultValue
        }
      }
      return validData
    },
    updateReviewAuthTypeFormShowHide(authSetupContent, selectedAuthType) {
      authSetupContent.form.forEach(form => {
        if (form.refId == 'stageAuthType' || form.refId == 'prodAuthType') {
          selectedAuthType = form.defaultValue
        }
        if (form.controlName == 'formGroup') {
          if (selectedAuthType.indexOf(form.refId) >= 0) {
            form.show = true
          } else {
            form.show = false
          }
        }
      })
    },
    updateReviewUserIdShowHide(contactsContent) {
      this.$store.state.createSubbrandStore.createTemplateData.content.forEach(
        content => {
          if (content.stepId == 'generalConfig') {
            let tier1 = _.findWhere(content.form, {
              refId: 'tier1CustomerCare'
            })
            if (tier1 && tier1.defaultValue == 'SUBBRAND') {
              this.$store.state.createSubbrandStore.showUserId = true
            } else {
              this.$store.state.createSubbrandStore.showUserId = false
            }
          }
        }
      )
      contactsContent.form.forEach(form => {
        if (form.controlName == 'formGroup') {
          form.formData.forEach(formData => {
            if (formData.refId == 'cUserId' || formData.refId == 'cUserId1') {
              formData.show = this.$store.state.createSubbrandStore.showUserId
            }
          })
        }
      })
    },

    updateReviewContactMember2ShowHide(contactsContent) {
      contactsContent.form.forEach(form => {
        if (form.controlName == 'formGroup' && form.refId == 'contact2') {
          var formDataObj = form.formData
          for (let i = 0; i <= formDataObj.length; i++) {
            if (formDataObj[i].show !== false) {
              if (formDataObj[i].defaultValue !== '') {
                form.show = true
                this.$store.state.createSubbrandStore.disableAddAnotherContactBtn = true
                break
              } else {
                form.show = false
                this.$store.state.createSubbrandStore.disableAddAnotherContactBtn = false
                break
              }
            }
            if (formDataObj[i].refId === 'resetUserIdPwd1') {
              if (formDataObj[i].defaultValue !== false) {
                formDataObj[i].show = true
              } else {
                formDataObj[i].show = false
              }
            }
          }
        }
        if (form.refId && form.refId == 'addAnotherContactBtn') {
          form.disabled = this.$store.state.createSubbrandStore.disableAddAnotherContactBtn
        }
      })
    },

    updateReviewJWT2ShowHide(authSetupContent, selectedAuthType) {
      authSetupContent.form.forEach(form => {
        if (
          (form.controlName == 'formGroup' && form.refId == 'jwt2') ||
          (form.controlName == 'formGroup' && form.refId == 'jwtprod2')
        ) {
          form.formData.forEach(formData => {
            if (formData.show !== false) {
              if (formData.defaultValue !== '') {
                form.show = true
                this.$store.state.createSubbrandStore.disableAddAnotherJWTBtn = true
              } else {
                form.show = false
                this.$store.state.createSubbrandStore.disableAddAnotherJWTBtn = false
              }
            }
          })
        }
        if (
          (form.refId && form.refId == 'addAnotherJWTBtn') ||
          (form.refId && form.refId == 'addAnotherProdJWT')
        ) {
          form.disabled = this.$store.state.createSubbrandStore.disableAddAnotherJWTBtn
        }
      })
    },
    toggleAppSection(prodAndAppContent) {
      this.$store.state.createSubbrandStore.createTemplateData.content.forEach(
        content => {
          if (content.stepId == 'generalConfig') {
            content.form.forEach(formData => {
              if (
                formData.refId == 'customerType'
              ) {
                this.$store.state.createSubbrandStore.customerType = formData.defaultValue
              } 
            })
          }
        }
      )
      prodAndAppContent.form.forEach(form => {
        if (form.groupName == 'AppGroup') {
            if(form.show) {
                form.show = this.$store.state.createSubbrandStore.customerType == 'API_APP' ? true : false
            }
        }
      })
    }
  }
}
</script>

<style scoped>
.v-application .theme--light.v-btn.primary.v-btn--disabled {
  background-color: #0070c9 !important;
  opacity: 0.5 !important;
  color: #fff !important;
}
</style>
